var map = {
	"./address/index.js": 1007,
	"./contact/index.js": 1010,
	"./gallery/index.js": 1015,
	"./image/index.js": 1018,
	"./link/index.js": 1022,
	"./page/index.js": 1026,
	"./text/index.js": 1030,
	"./title/index.js": 1033,
	"./youtube/index.js": 1036
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2055;



//////////////////
// WEBPACK FOOTER
// ./src/modules/edito/plugins ^\.\/.*\/index\.js$
// module id = 2055
// module chunks = 2